import React from 'react';
import _ from 'lodash';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { Heading, Button, Table } from 'arag-ui-lib';
import { TERTIARY, RIGHT, HEADING_3} from '../../../helpers/constants';
import NewDamageBandModal from "./newDamageBandModal";
import { getStepMessage } from '../../../helpers/premiumSettingsFunctions';

const Step2 = (props) => {

    const {
        currentStep,
        openDamageBandModal,
        getStartDamageBands,
        getEndDamageBands,
        changeStoreSettings,
        damageBands,
        setDamageBand,
        removeDamageBand,
        getDamageBandName,
        sortDamageBands,
        stepMessages,
    } = props;

    if (currentStep !== 2)
        return null;
    
    const sortedDamageBands = sortDamageBands(damageBands);
    const data = sortedDamageBands.map((band, index) => {
        return {
            damageBands: getDamageBandName(band),
            index: index
        };
    });
    const stepMessage = getStepMessage('2', stepMessages);
    return (
        <div >
            {
                openDamageBandModal 
                ?
                    <NewDamageBandModal 
                        openDamageBandModal={openDamageBandModal}
                        getStartDamageBands={getStartDamageBands}
                        getEndDamageBands={getEndDamageBands}
                        changeStoreSettings={changeStoreSettings}
                        setDamageBand={setDamageBand}
                        onClose={() => {
                            changeStoreSettings('openDamageBandModal', false);
                            changeStoreSettings('selectedDamages', []);
                            changeStoreSettings('checkedDamagesIds', []);
                        }}
                    />
                :
                    null
            }
            <Heading
                variant={HEADING_3}
                title={stepMessage}
                headingTestId={'edit-application-premium-setting-instructions'}
            />
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <Button
                    onClick={() => {changeStoreSettings('openDamageBandModal', true)} }
                    variant={TERTIARY}
                    arrowDirection={RIGHT}
                    label={CONTENT_STRINGS.ADD_NEW_DAMAGE_BAND}
                    buttonTestId={'edit-application-premium-setting-damage-bands-add-new-damage-band'}
                />
                <Table 
                    columns={[
                        {
                            propertyName: 'damageBands',
                            header: CONTENT_STRINGS.DAMAGE_BANDS,
                            id: 'damageBands',
                        }
                    ]}
                    data={data}
                    hasActions
                    actions={[{
                        key: 'removeDamageBand',
                        label: CONTENT_STRINGS.REMOVE,
                        callback: (row) => removeDamageBand(row.index),
                        actionTitle: CONTENT_STRINGS.ACTIONS,
                    }]}
                    striped
                    tableWrapperTestId={'edit-application-premium-setting-damage-bands-damage-bands'}
                />
            </div>
        </div>
    )
};

export default Step2;